import type { JSX } from 'react';
import { Link } from 'react-router-dom';

import PageHeader from '@/components/PageHeader';
import RemitForm from '@/forms/RemitForm/RemitForm';
import useNavigateToPage from '@/hooks/useNavigateToPage';
import { Remit } from '@/types/billing';
import Card from '@/ui/components/Card';
import Container from '@/ui/components/Container';

const NewRemit = (): JSX.Element | null => {
  const { navigateToEditRemit } = useNavigateToPage();
  const navigateToRemit = (remit: Remit) => {
    navigateToEditRemit(String(remit?.id));
  };
  return (
    <Container type="page">
      <PageHeader headingText="New Remit"></PageHeader>

      <Card className="relative">
        <RemitForm onSuccess={navigateToRemit}></RemitForm>
      </Card>

      <Link to="/billing" className="btn btn-secondary">
        Back
      </Link>
    </Container>
  );
};

export default NewRemit;
